import { render, staticRenderFns } from "./McChatbotPage.vue?vue&type=template&id=0c0c97bc&scoped=true"
import script from "./McChatbotPage.vue?vue&type=script&lang=js"
export * from "./McChatbotPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c97bc",
  null
  
)

export default component.exports